module.exports = __webpack_public_path__ + "static/media/embs_bleu.e82bbffb.png";